import React, { useEffect, useState } from "react";
import { MdDelete, MdModeEditOutline } from "react-icons/md";
import "../../css/Admin-Projects/AdminProductCard.css";
import { FaGithub } from "react-icons/fa";
import AdminEditProduct from "./AdminEditProduct";
import { toast } from "react-toastify";
import { deleteDoc, doc } from "firebase/firestore";
import { db } from "../../firebase";

const AdminProductCard = ({ data, fetchData,projectKey }) => {
  const [editProject, setEditProject] = useState(false);

  const handleDelete = async () => {
    if (window.confirm("Are you sure you want to delete this project?")) {
      try {
        await deleteDoc(doc(db, "projects", projectKey));
        toast.success("Project deleted successfully");
        fetchData();
      } catch (error) {
        toast.error("Failed to delete project");
      }
    }
  };


  return (
    <div className="product-container">
      <div className="product-card">
        <div className="product-image-div">
          <img
            src={data.projectImage}
            alt={data.projectName}
            className="product-image"
          />
        </div>
        <h1 className="product-name">{data.projectCategory}</h1>
        <p className="product-description">{data.projectName}</p>
        <div className="product-buttons">
          <a href={data.projectGitLink} target="_blank">
          <button className="gitBtn">
            <FaGithub style={{ marginRight: "0.5rem",fontSize:'2rem' }} />
            <span>Github</span>
          </button>
          </a>
          

          <div className="edit-button" onClick={() => setEditProject(true)}>
            <MdModeEditOutline style={{fontSize:'1.5rem' }}/>
          </div>

          <div className="delete-button" onClick={handleDelete}>
            <MdDelete style={{ fontSize: "1.5rem" ,color:"white"}} />
          </div>

        </div>
      </div>

      {editProject && (
                <AdminEditProduct onClose={() => setEditProject(false)} productData={data} fetchData={fetchData} projectKey={projectKey}/>
            )}
    </div>
  );
};

export default AdminProductCard;
